import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { TenchnicalPerformancePCComponent } from './tenchnical-performance-pc.component';

const routes: Routes = [
  {
    path: '',
    component: TenchnicalPerformancePCComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class TechnicalPerformancePCRoutingModule {}